import { replace } from "connected-react-router";
import { stringify } from "query-string";

import { getLocation } from "./selectors";
import { getNewParams } from "./getNewParams";

import { urlEncodeAllParamsButRefine } from "../../../helpers/urlEncodeAllParamsButRefine";

export const buildLocationQuery = ({
  query: params,
  pathname = getLocation().pathname,
  hash,
  preserve
}) => {
  const newParams = getNewParams({ params, preserve });

  delete newParams.affid;

  const location = {
    pathname,
    search: `?${stringify(urlEncodeAllParamsButRefine(newParams), {
      encode: false
    })}`,
    query: newParams
  };

  if (hash) {
    location.hash = `#${hash}`;
  }

  return location;
};

export const updateLocationQuery = ({
  query,
  pathname,
  hash,
  preserve = true
}) => replace(buildLocationQuery({ query, pathname, hash, preserve }));

export default updateLocationQuery;
